import { Injectable } from "@angular/core";

import { from, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ToastifyService } from "../../shared/toastify-service";
import { activatePlacardData, activatePlacardFailure, activatePlacardSuccess, addPlacardData, addPlacardFailure, addPlacardSuccess, deactivatePlacardData, deactivatePlacardFailure, deactivatePlacardSuccess, editPlacardData, editPlacardFailure, editPlacardSuccess, fetchPlacardsListingData, fetchPlacardsListingFailure, fetchPlacardsListingSuccess } from "./placard.actions";
import { DesignPlacard } from "../../core/models/designplacards.models";
import { PlacardService } from "../../core/services/placard.service";

@Injectable()
export class PlacardEffects {

    // FETCH PLACARDS
    fetchPlacardsListingData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPlacardsListingData),
            mergeMap(({ postdata }) =>
                this.placardService.getAllPlacards(postdata).pipe(
                    map((designplacards) => fetchPlacardsListingSuccess({ designplacards: designplacards })),
                    catchError((error) => of(fetchPlacardsListingFailure({ error })))
                )
            ),
        ),
    );

    fetchPlacardsListingFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPlacardsListingFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // ADD PLACARD RECORD
    addPlacardData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addPlacardData),
            mergeMap(({ postdata }) =>
                this.placardService.createPlacard(postdata).pipe(
                    map((placard: any) => addPlacardSuccess({ designplacard: placard })),
                    catchError(error => of(addPlacardFailure({ error })))
                )
            )
        )
    );

    addPlacardSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addPlacardSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Placard added successfully");
                })
            ),
        { dispatch: false }
    );

    addPlacardFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addPlacardFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // ADD PLACARD RECORD
    editPlacardData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(editPlacardData),
            mergeMap(({ postdata, id}) =>
                this.placardService.updatePlacard(postdata, id).pipe(
                    map((placard: any) => editPlacardSuccess({ designplacard: placard.data })),
                    catchError(error => of(editPlacardFailure({ error })))
                )
            )
        )
    );

    activatePlacardData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(activatePlacardData),
            mergeMap(({ postdata, id }) =>
                this.placardService.updatePlacard(postdata, id).pipe(
                    map((placard: any) => activatePlacardSuccess({ designplacard: placard.data })),
                    catchError(error => of(activatePlacardFailure({ error })))
                )
            )
        )
    );

    deactivatePlacardData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deactivatePlacardData),
            mergeMap(({ postdata, id }) =>
                this.placardService.updatePlacard(postdata, id).pipe(
                    map((placard: any) => deactivatePlacardSuccess({ designplacard: placard.data })),
                    catchError(error => of(deactivatePlacardFailure({ error })))
                )
            )
        )
    );

    

    editPlacardSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editPlacardSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Placard updated successfully");
                })
            ),
        { dispatch: false }
    );


    editPlacardFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editPlacardFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    activatePlacardSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(activatePlacardSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Placard activated");
                })
            ),
        { dispatch: false }
    );

    activatePlacardFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(activatePlacardFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    deactivatePlacardSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(deactivatePlacardSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Placard deactivated");
                })
            ),
        { dispatch: false }
    );

    deactivatePlacardFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(deactivatePlacardFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private toastifyService: ToastifyService,
        private placardService: PlacardService
    ) {
    }
}